import React from 'react';
import { Product } from '../../types';
import { getProductImageUrl, hasProductImage } from '../../utils/imageUtils';

interface ProductImageProps {
    product: Product | {
        code?: string;
        photo_url?: string;
        image_url?: string;
        designation?: string;
        name?: string;
    };
    size?: 'small' | 'medium' | 'large';
    className?: string;
    showContainer?: boolean;
}

const ProductImage: React.FC<ProductImageProps> = ({
    product,
    size = 'medium',
    className = '',
    showContainer = true
}) => {
    const getSizeClasses = () => {
        switch (size) {
            case 'small':
                return 'w-8 h-8';
            case 'medium':
                return 'w-12 h-12';
            case 'large':
                return 'w-20 h-20';
            default:
                return 'w-12 h-12';
        }
    };

    const getImageUrl = () => {
        // Try S3 image first if we have a product code
        if (hasProductImage(product)) {
            return getProductImageUrl(product.code!);
        }

        // Fallback to existing photo_url or image_url
        return product.photo_url || product.image_url;
    };

    const imageUrl = getImageUrl();
    const sizeClasses = getSizeClasses();
    const altText = product.designation || product.name || 'Product image';

    const imageElement = imageUrl ? (
        <img
            src={imageUrl}
            alt={altText}
            className="w-full h-full object-cover rounded-lg"
        />
    ) : (
        <div className="text-eldai-gray text-2xl">📦</div>
    );

    if (!showContainer) {
        return <div className={`${sizeClasses} ${className}`}>{imageElement}</div>;
    }

    return (
        <div className={`${sizeClasses} bg-eldai-gray-light rounded-lg flex items-center justify-center border border-eldai-gray img-container overflow-hidden ${className}`}>
            {imageElement}
        </div>
    );
};

export default ProductImage;
